__turbopack_context__.v({
  "className": "nunito_9bf84a14-module__0NW_Rq__className",
  "variable": "nunito_9bf84a14-module__0NW_Rq__variable",
});
